import type { ReactElement } from 'react';
import { memo } from 'react';

import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import { alpha, useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

interface MaterialOnTheFlyDialogTitleProps {
    styleNumber: number;
    styleName?: string;
    usageName: string;
}

const MaterialOnTheFlyDialogTitleRaw = ({
    styleNumber,
    styleName,
    usageName,
}: MaterialOnTheFlyDialogTitleProps): ReactElement => {
    const { palette } = useTheme();

    return (
        <DialogTitle>
            <Stack
                direction="row"
                spacing={4}
                sx={{
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}
            >
                <Stack>
                    <Typography
                        variant="headings.h2"
                        noWrap
                    >
                        {usageName} COMPOSITION
                    </Typography>
                    <Typography
                        variant="bodySmall.default"
                        sx={{ color: alpha(palette.text.primary, 0.7) }}
                    >
                        {styleNumber}
                        {styleName && (
                            <>
                                <span
                                    style={{
                                        color: alpha(palette.primary.main, 0.2),
                                    }}
                                >
                                    {' | '}
                                </span>
                                {styleName}
                            </>
                        )}
                    </Typography>
                </Stack>
            </Stack>
        </DialogTitle>
    );
};

const MaterialOnTheFlyDialogTitle = memo(MaterialOnTheFlyDialogTitleRaw);

export { MaterialOnTheFlyDialogTitle };
